import { Action } from '@ngrx/store';
import { CardModel } from '../../../shared/components/view/card/card.model';

export enum EDashboardActions {
    GetUserFavorites = '[Dashboard] Get User Favorites',
    GetUserSurveys = '[Dashboard] Get User Surveys',
    GetTemplates = '[Dashboard] Get Templates',
    SetUserFavorites = '[Dashboard] Set User Favorites',
    SetUserSurveys = '[Dashboard] Set User Surveys',
    SetTemplates = '[Dashboard] Set Templates'
}
export class GetUserFavorites implements Action {
    public readonly type = EDashboardActions.GetUserFavorites;
    constructor(public payload: number) { }
}

export class GetUserSurveys implements Action {
    public readonly type = EDashboardActions.GetUserSurveys;
    constructor(public payload: number) { }
}

export class GetTemplates implements Action {
    public readonly type = EDashboardActions.GetTemplates;
    
}
export class SetUserFavorites implements Action {
    public readonly type = EDashboardActions.SetUserFavorites;
    constructor(public payload: CardModel[]) { }
}

export class SetUserSurveys implements Action {
    public readonly type = EDashboardActions.SetUserSurveys;
    constructor(public payload: CardModel[]) { }
}

export class SetTemplates implements Action {
    public readonly type = EDashboardActions.SetTemplates;
    constructor(public payload: CardModel[]) { }
}
export type DashboardActions = GetUserFavorites | GetUserSurveys | GetTemplates | SetUserFavorites | SetUserSurveys | SetTemplates;
